import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import Providers from "./app/Providers";
import App from "./App";

import "./styles/global.css";

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("[App] Could not find #root element. Check your index.html.");
}

createRoot(rootElement).render(
  <StrictMode>
    <Providers>
      <App />
    </Providers>
  </StrictMode>,
);
